import { instance } from '@/api/instances'

const searchProcedure = async (store, { query, signal }) => {
  const queryJSON = JSON.stringify(query)
  const url = `procedure?q=${queryJSON}`
  return await search(store, { url, signal })
}

const searchTussProcedure = async (
  store,
  { query, signal, onlyPriced, typeOfService }
) => {
  const queryJSON = JSON.stringify(query)
  let url = `tuss_procedure?q=${queryJSON}&only_priced=${onlyPriced}`
  if (typeOfService) {
    url = `${url}&type_of_service=${typeOfService}`
  }
  return await search(store, { url, signal })
}

const search = async (store, { url, signal }) => {
  try {
    const response = await instance.get(url, {
      ...signal
    })

    return response
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'procedures/searchProcedure',
        message: 'Ops, não foi possível concluir a busca por procedimentos'
      },
      { root: true }
    )
  }
}

export default {
  searchProcedure,
  searchTussProcedure
}
